import WebflowPage from "../components/WebflowPage";
import useSeo from "../lib/useSeo";

export default function Pricing() {
  useSeo({
    title: "Gift Card Buyback Pricing & Fees — GC Nexon",
    description: "Zero hidden fees. Simple, transparent buyback rates for 100+ gift card brands. See exactly what you get paid before you submit any card.",
    path: "/pricing",
  });
  return <WebflowPage htmlPath="/site/pricing.html" title="Pricing — GC Nexon" />;
}
